<div class="grid-container full-height full v-pad">
    <div class="user-form-max-width">
        <h2>Cancel Chiefs Order</h2>
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <label for="cancelText">*Reason for Cancellation</label>
                <textarea id="cancelText" [(ngModel)]="cancelText" placeholder="Cancellation Note">{{cancelText}}</textarea>
            </div>
            <div class="cell small-12">
                <div class="checkbox display-inline-block">
                    <label class="inline">
                        <input type="checkbox" [(ngModel)]="isInternalVal" [checked]="isInternalVal" >
                        Make Cancellation Note Internal
                    </label>
                </div>
            </div>
            <div class="cell small-12 form-button-group">
                <button class="button hollow" (click)="cancelCO()" [disabled]="cancelText === ''">Cancel Chief's Order</button>
            </div>
        </div>
        <button class="back-link vertical-middle" (click)="goToReview()" type="button">
            <span aria-hidden="true" class="back-link-span">
                <svg-icon icon="icon-chevron-left" class="white" aria-hidden="true"></svg-icon>
            </span>
            <span>Previous</span>
        </button>
    </div>
</div>